
import React from "react";
import { RemoveActionProvider } from "@beeldit/coupons/coupons/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/coupons/coupons/actions/create/CreateActionContext";
import { ListActionProvider } from "@beeldit/coupons/coupons/actions/list/ListActionContext";
import CouponsPage from "@beeldit/coupons/coupons/pages/CouponPage";
import {EditActionProvider} from "@beeldit/coupons/coupons/actions/edit/EditActionContext";

export default function CouponsRouterWrapper() {
    return (
        <ListActionProvider>
            <RemoveActionProvider>
                <CreateActionProvider>
                    <EditActionProvider>
                        <CouponsPage />
                    </EditActionProvider>
                </CreateActionProvider>
            </RemoveActionProvider>
        </ListActionProvider>
    );
};